import React from 'react';
import { Box, List, ListItemButton } from '@mui/material';

function CreateProxy({
  node,
  handleClose,
  memberRecords,
  onAddProxy,
  setError
}) {
  const getPerson = (x) => {
    if (!x) return undefined;
    if (x?.pid) return x;
    if (x?.data?.pid) return x.data;
    return undefined;
  };

  const menuPerson = getPerson(node);

  const createProxyNow = () => {
    if (!menuPerson?.pid) {
      setError?.('Create Proxy failed: selected node pid missing.');
      return;
    }

    const original = (memberRecords || []).find(
      (p) => p.pid === menuPerson.pid
    );
    const spouseIds = Array.isArray(original?.spouseIds)
      ? original.spouseIds
      : [];
    // TGCLOUD-1597 — a proxy can now also stand in for a DONOR relationship, not only a marriage.
    // An identified donor is a real member, so without this their donor line runs right across the
    // pedigree with no way to shorten it. Spouse is preferred when the person has both, matching
    // the precedence in deriveProxies.
    const donorOfPids = Array.isArray(original?.donorOfPids)
      ? original.donorOfPids
      : [];

    const anchorPid = spouseIds.length
      ? spouseIds[spouseIds.length - 1]
      : donorOfPids[donorOfPids.length - 1];

    if (anchorPid == null) {
      setError?.(
        'Create Proxy: selected node has no spouse or donor relationship to proxy against.'
      );
      return;
    }

    onAddProxy?.({ originalPid: original.pid, proxyId: anchorPid });
    handleClose?.();
  };

  return (
    <Box>
      <List>
        <ListItemButton onClick={createProxyNow}>Create Proxy</ListItemButton>
      </List>
    </Box>
  );
}

export default CreateProxy;
